import styled from 'styled-components'

export const TabsOuterWrapper = styled.div`
  display: flex;
  width: fit-content;
  color: ${({ theme }) => theme.colors.primary} !important;
  font-size: 14px;
  border-radius: 10px;
  background-color: ${({ theme }) => `${theme.colors.background}`};
`

export const TabsWrapper = styled.div`
  display: flex;
  gap: 8px;
  padding: 4px;
  border-radius: 10px;
  background-color: ${({ theme }) => `${theme.colors.secondary}20`};
`
export const TabsItemContainer = styled.div``
export const TabsItem = styled.div`
  padding: 8px 24px;
  border-radius: 7px;
  font-weight: 600;
  cursor: pointer;
  &.active {
    background-color: ${({ theme }) => theme.colors.backgroundLite};
    color: ${({ theme }) => theme.colors.brand};
  }
`
